<app-layout class="container--md">
    <div class="inner-container">
        <div class="row row-title">
            <h1>{{resultsCount}} search results found with "{{filterByDocumentNumber}}"</h1>
            <p>Results include those documents that do not belong to you</p>
            <app-my-documents-listing [search]=true [filterByDocumentNumber]="filterByDocumentNumber" [docStatus]="'All'" [index]="0"
                [selectedIndex]="0"
                [uponCompletingDocumentLoadCallbackFunction]="onDocumentsListingLoad"></app-my-documents-listing>
        </div>
    </div>
</app-layout>